import ContentDetails from './ContentDetailsPage';
export type { ContentDetailsPageProps } from './ContentDetailsPage.types';

export default ContentDetails;
